import React from "react";
import { IMAGES } from "../../data/mock";
import * as Icons from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export default function Marketing() {
  const { t } = useLang();
  return (
    <section className="relative pt-24 pb-16 md:py-32 bg-[var(--aa-cream-warm)]">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <div className="grid md:grid-cols-2 gap-14 md:gap-16 items-center">
          <div className="reveal">
            <div className="text-[11px] tracking-[0.24em] uppercase text-[var(--aa-wine)] font-semibold mb-4">
              {t.marketing.eyebrow}
            </div>
            <h2 className="font-display font-light text-4xl md:text-6xl leading-[1.05] text-[var(--aa-ink)]">
              {t.marketing.h2a} <span className="italic">{t.marketing.h2b}</span>
            </h2>
            <p className="mt-6 text-[15px] md:text-lg text-[var(--aa-ink-soft)] leading-relaxed">
              {t.marketing.p}
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3">
              {t.marketing.chips.map((c, i) => {
                const Ico = Icons[c.icon] || Icons.Sparkles;
                return (
                  <div
                    key={i}
                    className="flex items-center gap-3 rounded-2xl bg-white border border-[var(--aa-line)] px-4 py-3"
                  >
                    <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-[var(--aa-wine)]/8 text-[var(--aa-wine)]">
                      <Ico className="w-4 h-4" />
                    </span>
                    <div className="text-[13.5px] font-medium text-[var(--aa-ink)]">{c.k}</div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="reveal relative">
            <div className="rounded-[28px] overflow-hidden aspect-[4/3] md:aspect-[4/5] shadow-[0_30px_80px_-30px_rgba(107,15,16,0.35)]">
              <img
                src={IMAGES.spa}
                alt="Spa lifestyle"
                className="w-full h-full object-cover object-[center_75%] md:object-center"
              />
            </div>
            <div className="hidden md:block absolute -bottom-8 -left-8 w-48 h-48 rounded-3xl overflow-hidden border-8 border-[var(--aa-cream-warm)] shadow-lg">
              <img src={IMAGES.dinner2} alt="Thai cooking class" className="w-full h-full object-cover" />
            </div>
            <div className="hidden md:flex absolute -top-6 -right-4 items-center gap-1.5 rounded-full bg-white border border-[var(--aa-line)] px-4 py-2 text-xs font-medium text-[var(--aa-wine)]">
              <Icons.Sparkles className="w-3.5 h-3.5" />
              {t.marketing.badge}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
